module.exports = __webpack_public_path__ + "img/ic_export-ready.923ab5eb.svg";